import { useMemo } from 'react';
import useAgentStore from '../components/pages/useAgentStore';
import { resolveAgentDisplayProfile } from '../utils/agentDisplayUtils';
import useEnsureAgentsLoaded from './useEnsureAgentsLoaded';

/**
 * Resolve display name, avatar URL, and system-agent sprite chrome for an agent.
 * @param {{ agent?: object, agentId?: string, agentName?: string, enabled?: boolean }} [params]
 */
export default function useAgentDisplayProfile({
  agent,
  agentId,
  agentName,
  enabled = true,
} = {}) {
  const needsLookup = enabled && !agent && (Boolean(agentId) || Boolean(agentName));
  useEnsureAgentsLoaded(needsLookup);

  const agents = useAgentStore((state) => state.agents);

  return useMemo(
    () => resolveAgentDisplayProfile({ agent, agentId, agentName, agents }),
    [agent, agentId, agentName, agents]
  );
}
